<template>
    <el-dialog
        class="modal-body-padding-top-10 modal-body-padding-bottom-0"
        top="5vh"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        :title="title"
        width="1200px"
        append-to-body
        :before-close="handleClose">
        <div class="content-wrap ml20">
            <el-form ref="form" :model="formItem" :rules="isAddAd?addRules:rules" label-width="110px" inline>
                <el-form-item label="Campaign Group:" prop="org_id" class="mb6 label-required">
                    <el-select v-model="formItem.org_id" ref="select_org_id" filterable reserve-keyword @change="changeSelect('org_id',$event)" :disabled="actionType=='campaignAddNegativeKeyword'||actionType=='adGroupAddNegativeKeyword'" :loading="remoteOrgLoading" placeholder="Enter campaign group ID or name keyword to search" class="width245" popper-class="select-option-long-text-wrap">
                        <el-option
                            v-for="item in orgList"
                            :key="item.value"
                            :label="item.label+'【'+item.value+'】'"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="Associated Campaign:" prop="campaign_id" class="mb6">
                    <el-tooltip class="item" effect="dark" content="Please select the associated campaign group first" :disabled="!!formItem.org_id||actionType=='campaignAddNegativeKeyword'" placement="top">
                        <el-select v-model="formItem.campaign_id" ref="select_campaign_id" filterable reserve-keyword @change="changeSelect('campaign_id',$event)" :disabled="!formItem.org_id||actionType=='campaignAddNegativeKeyword'||actionType=='adGroupAddNegativeKeyword'" :loading="remoteCampaignLoading" placeholder="Enter campaign ID or name keyword to search" class="width245" popper-class="select-option-long-text-wrap">
                            <el-option
                                v-for="item in campaignList"
                                :key="item.value"
                                :label="item.label+'【'+item.value+'】'"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-tooltip>
                </el-form-item>
                <el-form-item label="Belonging to Ad Group:" class="mb6">
                    <el-tooltip class="item" effect="dark" content="Please select an campaign first" :disabled="!!formItem.campaign_id||actionType=='campaignAddNegativeKeyword'" placement="top">
                        <el-select v-model="formItem.adgroup_id" ref="select_adgroup_id" clearable filterable reserve-keyword @change="changeSelect('adgroup_id',$event)" :disabled="!formItem.org_id||!formItem.campaign_id||actionType=='adGroupAddNegativeKeyword'" :loading="remoteAdGroupLoading"  placeholder="Enter Ad group ID or name keyword to search" class="width245" popper-class="select-option-long-text-wrap">
                            <el-option
                                v-for="item in adGroupList"
                                :key="item.value"
                                :label="item.label+'【'+item.value+'】'"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-tooltip>
                </el-form-item>
            </el-form>

            <div class="tool-bar">
                <div class="batch-tool"  v-if="checkedList.length>0">
                    <span class="font12px">{{checkedList.length}} Items Selected</span>
                    <el-divider direction="vertical"></el-divider>
                    <el-link type="primary" :underline="false" @click="batchChangeMatchType('Exact Match')">Change to Exact Match</el-link>
                    <el-divider direction="vertical"></el-divider>
                    <el-link type="primary" :underline="false" @click="batchChangeMatchType('Broad Match')">Change to Broad Match</el-link>
                    <el-divider direction="vertical"></el-divider>
                    <el-popover
                        placement="bottom"
                        width="160">
                        <p>Are you sure you want to delete?</p>
                        <div style="text-align: right; margin: 0">
                            <el-button size="mini" type="text" @click="cancelBatchRemove">Close</el-button>
                            <el-button type="primary" size="mini" @click="batchRemove">Confirm</el-button>
                        </div>
                        <el-link slot="reference" type="danger" :underline="false">Delete</el-link>
                    </el-popover>
                    <span class="close-btn" @click="hideBatchTool">x</span>

                </div>
                <div class="add-tool" v-else>
                    <el-input
                        resize="none"
                        type="textarea"
                        :rows="1"
                        :autosize="{ minRows: 1, maxRows: 2 }"
                        v-model.trim="add_input"
                        :disabled="!isAddAd&&(!formItem.org_id||!formItem.campaign_id)"
                        @keyup.enter.native.prevent.stop="checkNegativeKeywordCopy"
                        @input="formatInputVal"
                        size="mini"
                        class="add-input"
                        clearable
                        :placeholder="!formItem.campaign_id?'Please select a campaign before adding negative keywords':'Add negative keywords, separated by commas (maximum 5000 per group). After entering, click the add button on the right or press the Enter key to add.'">
                    </el-input>
                    <el-button type="primary" size="mini" class="ml20" :disabled="add_input.length<=0" :loading="addBtnLoading" @click="checkNegativeKeywordCopy" plain>Add</el-button>
                    <div class="text-color-error font12px mt4" v-if="addErrText&&addErrText.length>0&&addErrText!='[]'">{{addErrText}}</div>
                </div>
            </div>
            <div class="data-list">
                <!---->
                <el-table
                    border
                    :header-cell-style="{color:'#333'}"
                    :data="dataList"
                    max-height="350"
                    style="width: 100%;"
                    ref="multipleTable"
                >
                    <el-table-column
                        type="select"
                        width="50"
                        align="center"
                        fixed="left"
                    >
                        <template slot="header" slot-scope="scope">
                            <el-checkbox :indeterminate="indeterminate" :disabled="allList.length<=0" v-model="isCheckAll" @change="handleCheckAllChange"></el-checkbox>
                        </template>
                        <template slot-scope="scope">
                            <el-checkbox v-model="scope.row.checked" @change="handleRowSelectChange"></el-checkbox>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="key_word_text"
                        label="Negative keywords"
                        min-width="150">
                        <template slot="header" slot-scope="scope">
                            <i class="text-color-error"> * </i>Negative keywords
                            <el-tooltip class="item" effect="dark" content="When the match type is exact match, the keyword will be enclosed in brackets (i.e., [negative keyword])." placement="top">
                                <i class="el-icon-question pointer"></i>
                            </el-tooltip>
                        </template>
                        <template slot-scope="scope">
                            <span v-if="scope.row.match_type=='精准匹配'||scope.row.match_type=='Exact Match'">[{{scope.row.key_word_text}}]</span>
                            <span v-else>{{scope.row.key_word_text}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="match_type"
                        label="Match Type"
                        align="center"
                        width="200">
                        <template slot="header" slot-scope="scope">
                            <span class="label-required"><i class="text-color-error"> * </i>Match Type</span>
                        </template>
                        <template slot-scope="scope">
                            <el-select v-model="scope.row.match_type" size="mini">
                                <el-option label="Broad Match" value="Broad Match">Broad Match</el-option>
                                <el-option label="Exact Match" value="Exact Match">Exact Match</el-option>
                            </el-select>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="action"
                        label="Actions"
                        align="center"
                        width="150">
                        <template slot-scope="scope">
                            <el-button type="danger" size="mini" @click="removeRow(scope.row)">Delete</el-button>
                        </template>
                    </el-table-column>

                    <div slot="empty" style="min-height: 200px;margin-top:100px;width: 600px;">
                        <p class="text-color-gray">If you do not select a belonging ad group, it means that the negative keyword will be added at the campaign level. Campaign negative keywords apply to all associated ad groups and are managed at the campaign level. You may consider allowing time for the campaign to run before analyzing ad performance to understand which keywords might not work for you. Adding too many negative keywords may limit your ad exposure.</p>
                    </div>
                </el-table>
                <div :style="{textAlign: 'right', paddingTop: '10px'}">
                    <el-pagination
                        layout="prev, pager, next"
                        :page-size="rowNum"
                        :current-page="pn"
                        @current-change="handleCurrentChange"
                        :total="total">
                    </el-pagination>
                </div>
            </div>
        </div>

        <div slot="footer" class="dialog-footer tac">
            <el-button type="default" @click="handleClose" class="action-btn ml20">Close</el-button>
            <el-button type="primary" @click="handleSubmit" :loading="submitLoading" :disabled="allList.length<=0" class="action-btn ml20">Submit</el-button>
        </div>

        <el-dialog
            :title="null"
            :visible.sync="notifyVisible"
            :close-on-click-modal=false
            :close-on-press-escape=false
            :show-close=false
            :destroy-on-close=true
            append-to-body
            width="450px"
            custom-class="apple-dialog-err">
            <div>
                <h5 class="tac font16px">Creating, please wait…</h5>
                <p class="tac text-color-error pt10 pb20">Please do not refresh the page, refreshing the page may result in not receiving the latest results in time.</p>
            </div>
        </el-dialog>
    </el-dialog>
</template>

<script>
    import {mapGetters} from 'vuex';
    import API from '@/api/marketManage/apple/index-en';
    import { get_keyword_modal_err_html,get_err_info } from "../../components/getFlagHtml.js";

    export default {
        name: "NegativeKeywordModal",
        props:{
            title:{
                type:String,
                default:'Add Negative Keywords',
            },
            actionRows:Array,
            actionType:{
                validator: function (value) {
                    // 仅接受以下值
                    let pageList = [
                        '',
                        'campaignAddNegativeKeyword',   // 创建新广告系列
                        'adGroupAddNegativeKeyword',    // 创建新广告组
                        'keywordAddAsNegativeKeyword',     // 关键词列表-添加为否定关键词
                        'searchTermAddAsNegativeKeyword',     // 搜索词列表-添加为否定关键词
                        'negativeKeywordAddNegativeKeyword',     // 否定关键词列表-添加否定关键词
                        'negativeKeywordCopyNegativeKeyword',     // 否定关键词列表-复制否定关键词

                        'adGroupAddKeyword',    // 创建新广告组
                        'keywordAddKeyword',     // 关键词列表-添加关键词
                        'keywordCopyKeyword',     // 关键词列表-复制关键词
                        'searchTermAddAsKeyword',     // 搜索词列表-添加为关键词
                    ];
                    return pageList.includes(value);
                },
            },
            formData:{
                type:Object,
                default: ()=>{
                    return {};
                },
            },
        },
        data(){
            return {
                dialogVisible:false,
                submitLoading:false,
                add_input:'',
                formItem:{
                    org_id:'',
                    campaign_id:'',
                    adgroup_id:'',
                },
                rules:{
                    org_id:[
                        { required: true, message: 'Please select an associated campaign group', trigger: 'change' }
                    ],
                    campaign_id:[
                        { required: true, message: 'Please select an associated campaign', trigger: 'change' }
                    ],
                },
                addRules:{
                    org_id:[
                        { required: true, message: 'Please select an associated campaign group', trigger: 'change' }
                    ],
                },
                orgList:[],
                campaignList:[],
                adGroupList:[],
                notifyTip:null,
                notifyVisible:false,

                remoteOrgLoading:false,
                remoteCampaignLoading:false,
                remoteAdGroupLoading:false,
                addBtnLoading:false,
                oldSelectVal:{
                    org_id:'',
                    campaign_id:'',
                    adgroup_id:'',
                },
                total: 0,
                pn: 1,
                allList:[],
                rowNum:50,
                isCheckAll:false,   // 批量是否全选
                addErrText:'',

            }
        },
        computed:{
            ...mapGetters(['cur_tab_page']),
            dataList(){
                let start = this.rowNum * (this.pn - 1)
                let end = this.rowNum * (this.pn - 1) + this.rowNum
                return this.allList.slice(start,end)
            },
            isAddAd(){
                return this.actionType=='campaignAddNegativeKeyword'||this.actionType == 'adGroupAddNegativeKeyword';
            },
            checkedList(){
                return this.allList.filter(item=>item.checked);
            },
            indeterminate(){
                let checkedList = this.checkedList;
                return this.allList.length>0&&checkedList.length>0&&checkedList.length<this.allList.length;
            },
        },
        mounted(){
           
        },
        methods:{
            handleClose(val){
                console.log('handleClose',val);
                this.dialogVisible = false;
                this.resetForm();
            },
            resetForm(){
                this.formItem.org_id = '';
                this.formItem.campaign_id = '';
                this.formItem.adgroup_id = '';
                this.add_input = '';
                this.submitLoading = false;
                this.$refs.form.resetFields();
                this.orgList = [];
                this.campaignList = [];
                this.adGroupList = [];
                this.allList = [];
                this.total = 0;
                this.addErrText = '';
                this.isCheckAll = false;
            },

            handleSubmit(){
                let noMatchTypeList = this.allList.filter(item=>!item.match_type).map(item=>item.key_word_text);
                if(noMatchTypeList.length>0){
                    let matchTypeText = noMatchTypeList.length>0?`<p class="font12px">The following negative keywords have no match type set：</p><p class="pl20 font12px">${noMatchTypeList.join('，')}</p>`:'';
                    let htmlStr = `<div style="max-height: 300px;overflow-y: auto;padding-right: 10px;">${matchTypeText}</div>`;
                    this.$alert(htmlStr, 'Submit Err', {
                        dangerouslyUseHTMLString:true,
                        type:"error",
                        confirmButtonText: 'Confirm',
                    });
                    return false;
                }

                let repeatArr = [];
                let tempObj = {};
                this.allList.forEach(item=>{
                    if(!tempObj[item.key_word_text]){
                        tempObj[item.key_word_text] = true;
                    }else{
                        repeatArr.push(item.key_word_text);
                    }
                });
                tempObj = null;
                if(repeatArr.length>0){
                    this.$notify.error({
                        title: 'Submit Error',
                        message: '<div style="max-height: 300px;overflow-y: auto;padding-right: 10px;">Duplicate keywords exist in the list：'+repeatArr.join('，')+'</div>',
                        dangerouslyUseHTMLString: true,
                        duration: 0,
                    });
                    return false;
                }

                if(this.isAddAd){
                    this.$emit('save',this.allList);
                    this.handleClose();
                    return false;
                }
                this.$refs.form.validate((valid) => {
                    if (valid) {
                        console.log('handleSubmit');
                        if(!this.actionType) return ;
                        this.submitLoading = true;
                        this.notifyVisible = true;
                        let currency_time = new Date().valueOf()
                        let current_name = `keywordModal_${currency_time}`

                        let rowData = this.allList.map(item=>{
                            return {
                                text:item.key_word_text,
                                match_type:(item.match_type=='精准匹配'||item.match_type=='Exact Match')?'EXACT':((item.match_type=='广泛匹配'||item.match_type=='Broad Match')?'BROAD':''),
                            }
                        });

                        API[this.actionType]({
                            current_name:current_name,
                            org_id:this.formItem.org_id,
                            campaign_id:this.formItem.campaign_id,
                            adgroup_id:this.formItem.adgroup_id,
                            data:JSON.stringify(rowData),
                        },{
                            timeout: 120*1000,
                        }).then(res=>{
                            this.notifyVisible = false;
                            this.submitLoading = false;
                            console.log('createKeywords',res);
                            let resData = res.data||{};
                            let msgText = resData.msg||'';
                            this.$notify.success({
                                title: res.info||'Success',
                                dangerouslyUseHTMLString: true,
                                message: '<p>'+msgText+'</p>',
                            });
                            this.dialogVisible = false;
                            this.$emit('update');
                            this.resetForm();

                        },err=>{
                            this.notifyVisible = false;
                            this.submitLoading = false;
                            console.log('createKeywords err',err);
                            if(err.code =='403'){
                                this.$confirm(err.info, 'Prompt', {
                                    confirmButtonText: 'Refresh',
                                    cancelButtonText: 'Cancel',
                                    type: 'warning',
                                    showClose: false,
                                    closeOnClickModal: false,
                                    closeOnPressEscape: false
                                }).then(() => {
                                    window.location.reload()
                                }).catch(() => {
                                    this.loading = false
                                });
                                return
                            }

                            let errData = err.data||{};
                            let errMsg = errData.msg||'';
                            let errInfo = err.info||'Timeout: Operation result not returned. Please log in to the media platform manually to confirm the operation result or try again.';
                            let repeat_keyword = errData.repeat_keyword||[];
                            if(repeat_keyword.length>0){
                                console.log('repeat_keyword',repeat_keyword);
                                let htmlStr = `<p class="text-color-error">${errMsg} Delete?</p><p class="break-word">${repeat_keyword.join(',')}</p>`;
                                this.$confirm(htmlStr, errInfo, {
                                    closeOnPressEscape:false,
                                    dangerouslyUseHTMLString: true,
                                    confirmButtonText: 'Delete',
                                    cancelButtonText: 'Cancel',
                                    confirmButtonClass: 'danger-btn1',
                                    type: 'warning',
                                }).then(() => {
                                    console.log(repeat_keyword,'删除');
                                    repeat_keyword.forEach(item=>{
                                        let actionRow = this.allList.find(inner=>inner.key_word_text==item);
                                        this.removeRow(actionRow);
                                    });
                                    if(this.allList.length>0){
                                        this.handleSubmit();
                                    }else{
                                        this.$notify.error({
                                            title: 'Prompt',
                                            message: 'The keyword list is empty. Please add keywords.',
                                        });
                                    }
                                }).catch(() => {
                                    console.log(repeat_keyword,'取消')
                                });
                            }else{
                                let errList = (errData.error||{}).errMsg||[];

                                let htmlStr=get_keyword_modal_err_html(errInfo, errMsg, errList,current_name);
                                this.notifyTip = this.$notify({
                                    showClose: false,
                                    duration: 0,
                                    dangerouslyUseHTMLString: true,
                                    message: htmlStr,
                                    customClass:'width400',
                                });
                                this.$store.commit('apple/ADD_NOTIFY',{
                                    id: `${current_name}_close`,
                                    value:this.notifyTip,
                                });
                            }
                        });

                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            showModal(){
                this.dialogVisible = true;
                this.$nextTick(()=>{
                    let actionRows = this.actionRows||[];
                    let formData = this.formData||{};
                    this.getOrgSelectorList();


                    if(['campaignAddNegativeKeyword','adGroupAddNegativeKeyword','keywordAddAsNegativeKeyword','searchTermAddAsNegativeKeyword','negativeKeywordCopyNegativeKeyword'].includes(this.actionType)){
                        if(formData.org_id){
                            this.formItem.org_id = formData.org_id;
                            this.oldSelectVal.org_id = formData.org_id;
                            this.orgList = [{
                                value:formData.org_id,
                                label:formData.org_name,
                            }];
                            this.getCampaignSelectorList();
                        }
                        if(formData.campaign_id){
                            this.formItem.campaign_id = formData.campaign_id;
                            this.oldSelectVal.campaign_id = formData.campaign_id;
                            this.campaignList = [{
                                value:formData.campaign_id,
                                label:formData.campaign_name,
                            }];
                            this.getAdGroupSelectorList();
                        }
                        if(formData.adgroup_id&&formData.adgroup_id!='-'){
                            this.formItem.adgroup_id = formData.adgroup_id;
                            this.oldSelectVal.adgroup_id = formData.adgroup_id;
                            this.adGroupList = [{
                                value:formData.adgroup_id,
                                label:formData.adgroup_name,
                            }];
                        }

                        let dataList = [];
                        actionRows.forEach(item=>{
                            if(!dataList.find(inner=>inner.key_word_text==item.key_word_text&&inner.match_type==item.match_type)){
                                dataList.push({
                                    key_word_text:item.key_word_text,
                                    match_type:item.match_type,
                                    checked:false,
                                });
                            }
                        });
                        this.total = dataList.length ? dataList.length : 0;
                        this.allList = dataList;
                    }

                });

            },
            getOrgSelectorList(){
                this.remoteOrgLoading = true;
                API.getOrgSelectorList({
                    source_page:this.cur_tab_page,
                }).then(res=>{
                    let resData = res.data||[];
                    this.orgList = resData.map(item=>{
                        return {
                            value:item.org_id,
                            label:item.org_name,
                        }
                    });
                    this.remoteOrgLoading = false;
                },err=>{
                    console.log('getOrgSelectorList err',err);
                    this.orgList = [];
                    this.remoteOrgLoading = false;
                    if (err.code == '403') {
                        this.$confirm(err.info||'Request Error', 'Prompt', {
                            confirmButtonText: 'Refresh',
                            cancelButtonText: 'Cancel',
                            type: 'warning',
                            showClose: false,
                            closeOnClickModal: false,
                            closeOnPressEscape: false
                        }).then(() => {
                            window.location.reload()
                        }).catch(() => {
                        });
                        return
                    }
                })
            },
            getCampaignSelectorList(){
                this.remoteCampaignLoading = true;
                API.getCampaignSelectorList({
                    org_id:this.formItem.org_id,
                    search:'',
                    source_page:this.cur_tab_page,
                    supply_source:2,
                }).then(res=>{
                    let resData = res.data||[];
                    this.campaignList = resData.map(item=>{
                        return {
                            value:item.campaign_id,
                            label:item.campaign_name,
                        }
                    });
                    this.remoteCampaignLoading = false;
                },err=>{
                    console.log('getCampaignSelectorList err',err);
                    this.campaignList = [];
                    this.remoteCampaignLoading = false;
                    if (err.code == '403') {
                        this.$confirm(err.info||'Request Error', 'Prompt', {
                            confirmButtonText: 'Refresh',
                            cancelButtonText: 'Cancel',
                            type: 'warning',
                            showClose: false,
                            closeOnClickModal: false,
                            closeOnPressEscape: false
                        }).then(() => {
                            window.location.reload()
                        }).catch(() => {
                        });
                        return
                    }
                })
            },
            getAdGroupSelectorList(){
                this.remoteAdGroupLoading = true;
                API.getAdGroupSelectorList({
                    org_id:this.formItem.org_id,
                    campaign_id:this.formItem.campaign_id,
                    search:'',
                    source_page:this.cur_tab_page,
                }).then(res=>{
                    let resData = res.data||[];
                    this.adGroupList = resData.map(item=>{
                        return {
                            value:item.adgroup_id,
                            label:item.adgroup_name,
                        }
                    });
                    this.remoteAdGroupLoading = false;
                },err=>{
                    console.log('getAdGroupSelectorList err',err);
                    this.adGroupList = [];
                    this.remoteAdGroupLoading = false;
                    if (err.code == '403') {
                        this.$confirm(err.info||'Request Error', 'Prompt', {
                            confirmButtonText: 'Refresh',
                            cancelButtonText: 'Cancel',
                            type: 'warning',
                            showClose: false,
                            closeOnClickModal: false,
                            closeOnPressEscape: false
                        }).then(() => {
                            window.location.reload()
                        }).catch(() => {
                        });
                        return
                    }
                })
            },
            checkNegativeKeywordCopy(){
                this.add_input = this.add_input.replace(/,$/,'');
                let inputVal = this.add_input;

                let keyword_type = 'campaign_negative';
                if(this.actionType=='adGroupAddNegativeKeyword'){
                    keyword_type = 'adgroup_negative';
                }else if(this.formItem.adgroup_id){
                    keyword_type = 'adgroup_negative';
                }

                let currency_time = new Date().valueOf()
                let current_name = `checkKeywordModal_${currency_time}`
                this.addBtnLoading = true;
                this.addErrText = '';
                API.checkAddKeywords({
                    current_name:current_name,
                    keyword_type:keyword_type,        // 关键词,campaign_negative：广告系列否定关键词,adgroup_negative：广告组否定关键词
                    texts:inputVal,
                    org_id:this.formItem.org_id,
                    campaign_id:this.formItem.campaign_id,
                    adgroup_id:this.formItem.adgroup_id,
                },{
                    timeout: 120*1000,
                }).then(res=>{
                    this.addBtnLoading = false;
                    let resData =res.data||{};
                    let res_keyword = resData.res_keyword||[];

                    if(res_keyword.length+this.allList.length>5000){
                        let diff = res_keyword.length+this.allList.length - 5000;
                        this.addErrText = 'Ad groups can contain a maximum of 5000 keywords. Exceeding by '+diff+'. Cannot continue adding.';
                    }else{
                        res_keyword.forEach(item=>{
                            if(!this.allList.find(inner=>inner.key_word_text==item)&&!!item){
                                this.allList.unshift({
                                    key_word_text:item,
                                    match_type:'Exact Match',
                                    bid_amount:'',
                                    checked:false,
                                })
                            }
                        });
                        this.add_input = '';
                        this.pn = 1;
                        this.total = this.allList.length;
                    }
                },err=>{
                    console.log('checkNegativeKeywordCopy err',err);
                    this.addBtnLoading = false;
                    if (err.code == '403') {
                        this.$confirm(err.info||'Request Error', 'Prompt', {
                            confirmButtonText: 'Refresh',
                            cancelButtonText: 'Cancel',
                            type: 'warning',
                            showClose: false,
                            closeOnClickModal: false,
                            closeOnPressEscape: false
                        }).then(() => {
                            window.location.reload()
                        }).catch(() => {
                        });
                        return
                    }
                    let errData = err.data||{};
                    let errInfo = err.info||'Error';
                    let errMsg = errData.msg||'';
                    let repeat_keyword = errData.repeat_keyword||[];
                    if(repeat_keyword.length>0){
                        this.addErrText = errMsg+':'+repeat_keyword.join('，');
                    }else{
                        this.addErrText = errMsg||errInfo;
                    }




                    // let res_keyword = errData.res_keyword||[];
                    // res_keyword.forEach(item=>{
                    //     if(!this.allList.find(inner=>inner.key_word_text==item)&&!!item){
                    //         this.allList.unshift({
                    //             key_word_text:item,
                    //             match_type:'精准匹配',
                    //             bid_amount:'',
                    //             checked:false,
                    //         })
                    //     }
                    // });
                    //
                    // if(repeat_keyword.length>0){
                    //     console.log('repeat_keyword',repeat_keyword);
                    //     let htmlStr = `<p class="text-color-error">${errInfo}，Delete?</p><p>${repeat_keyword.join(',')}</p>`;
                    //     this.$confirm(htmlStr, '提示', {
                    //         closeOnPressEscape:false,
                    //         dangerouslyUseHTMLString: true,
                    //         confirmButtonText: 'Delete',
                    //         cancelButtonText: 'Cancel',
                    //         confirmButtonClass: 'danger-btn1',
                    //         type: 'warning',
                    //     }).then(() => {
                    //         this.add_input = errData.res_text;
                    //     }).catch(() => {
                    //
                    //     });
                    // }else{
                    //     let errList = (errData.error||{}).errMsg||[];
                    //
                    //     let htmlStr=get_keyword_modal_err_html(errInfo, errMsg, errList,current_name);
                    //     this.notifyTip = this.$notify({
                    //         showClose: false,
                    //         duration: 0,
                    //         dangerouslyUseHTMLString: true,
                    //         message: htmlStr,
                    //         customClass:'width400',
                    //     });
                    //     this.$store.commit('apple/ADD_NOTIFY',{
                    //         id: `${current_name}_close`,
                    //         value:this.notifyTip,
                    //     });
                    //     this.add_input = errData.res_text;
                    // }
                })
            },
            removeRow(row){
                let rowIndex = this.allList.findIndex(item=>item.key_word_text==row.key_word_text&&item.match_type==row.match_type);
                this.allList.splice(rowIndex,1);
                this.total =  this.allList.length;
                this.handleRowSelectChange();
            },
            batchChangeMatchType(val){
                this.checkedList.forEach(item=>{
                    item.match_type = val;
                });
            },
            batchRemove(){
                this.checkedList.forEach(item=>{
                    this.removeRow(item);
                });
            },
            cancelBatchRemove(){
                /* 隐藏弹窗，随便找个元素click一下就好 */
                let $batchTool = document.querySelector('.batch-tool');
                if($batchTool){
                    $batchTool.click();
                }
            },
            changeSelect(type,val){
                console.log('changeOrgSelect',val);
                // if(!this.oldSelectVal[type]){
                //     this.oldSelectVal[type] = this.formItem[type];
                // }else if(val!=this.oldSelectVal[type]){
                //     let typeMap = {
                //         org_id:'广告系列组',
                //         campaign_id:'广告系列',
                //         adgroup_id:'广告组',
                //     };
                //     this.$confirm('修改'+typeMap[type]+'，已填写的内容将会被清空', '提示', {
                //         closeOnPressEscape:false,
                //         dangerouslyUseHTMLString: true,
                //         confirmButtonText: 'Confirm',
                //         cancelButtonText: 'Cancel',
                //         type: 'warning',
                //     }).then(() => {
                //         console.log('resetData',type);
                //         this.resetData(type);
                //         /*手动隐藏下拉筛选框*/
                //         this.$refs['select_'+type].blur();
                //         this.oldSelectVal[type] = this.formItem[type];
                //     }).catch(() => {
                //         this.formItem[type] = this.oldSelectVal[type];
                //         /*手动隐藏下拉筛选框*/
                //         this.$refs['select_'+type].blur();
                //     });
                // }

                if(type=='org_id'&&val!=''){
                    this.formItem.campaign_id = '';
                    this.formItem.adgroup_id = '';
                    this.campaignList = [];
                    this.adGroupList = [];
                    this.getCampaignSelectorList();
                }
                if(type=='campaign_id'&&val!=''){
                    this.formItem.adgroup_id = '';
                    this.adGroupList = [];
                    this.getAdGroupSelectorList();
                }
            },
            resetData(type){
                console.log('resetData',111,type);
                if(type=='org_id'){
                    this.formItem.campaign_id = '';
                    this.formItem.adgroup_id = '';
                }else if(type=='campaign_id'){
                    this.formItem.adgroup_id = '';
                }
                this.add_input = '';
                this.dataList = [];
                this.isCheckAll = false;
                this.allList = [];
                this.addErrText = '';
                this.$nextTick(()=>{
                    this.$refs.form.clearValidate();
                });
            },
            formatInputVal(val){
                this.add_input = val.replaceAll('\n',',').replaceAll('\r\n',',');
            },
            handleCurrentChange(val) {
                this.pn = val
            },
            hideBatchTool(){
                console.log('hideBatchTool');
                this.allList.forEach(item=>{
                    item.checked = false;
                });
                this.isCheckAll = false;
            },
            handleCheckAllChange(val){
                console.log('handleCheckAllChange',val);
                this.allList.forEach(item=>{
                    item.checked = val;
                })
            },
            handleRowSelectChange(){
                this.isCheckAll = this.allList.length>0&&this.allList.every(item=>item.checked);
            },
        },
    }
</script>

<style lang="scss" scoped>
    .content-wrap ::v-deep .el-form-item__label{
        line-height: 20px;
    }
    .tool-bar{
        min-height: 50px;
        background-color: #f2f2f2;
        /*border: solid silver 1px;*/
        padding: 10px;
        margin: 10px 0;
        .add-input{
            width: calc(100% - 120px);
        }

        .batch-tool{
            width: 700px;
            height: 28px;
            line-height: 26px;
            background-color: #fff;
            border: solid silver 1px;
            padding-left: 10px;
            position: relative;
            .close-btn{
                display: inline-block;
                width:20px;
                text-align: center;
                height: 20px;
                line-height: 20px;
                position: absolute;
                right: 5px;
                top: 3px;
                cursor: pointer;
                &:hover{
                    color: #333;
                }
            }
        }
    }

    .mb6{
        margin-bottom: 6px;
    }
    .width245{
        width: 245px;
    }

</style>
